module.exports = __webpack_public_path__ + "static/media/cocktails.022c046c.pdf";